import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

import { AuthContext } from "../contexts/Auth";
import { db } from "../Firebase.js";
import {
  getDocs,
  collection,
} from "firebase/firestore";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../styles/count.css";

import { DoubleBubble } from "react-spinner-animated";
import "react-spinner-animated/dist/index.css";

import searchIcon from "../images/icons/icon-search-primary.svg";
import downloadIcon from "../images/icons/icon-upload-primary.svg";

function IssueReport() {
  // const history = useHistory();
  const params = useParams();

  const [fetchDB, setFetchDB] = useState(true);
  const [loadingText, setLoadingText] = useState("");

  const { userInfo } = useContext(AuthContext);
  const [vins, setVins] = useState([]);

  const [globalFilter, setGlobalFilter] = useState(null);

  var today = new Date();
  const date =
    today.getFullYear() + "_" + (today.getMonth() + 1) + "_" + today.getDate();

  const cols = [
    { field: "vin", header: "Vin" },
    { field: "note", header: "Note" },
    { field: "entry", header: "Entry" },
    { field: "date", header: "Date" },
    { field: "time", header: "Time" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  useEffect(() => {
    setLoadingText("Fetching Issues");
    setFetchDB(true);
    if (userInfo !== undefined) {
      getLotReport(params.autogroup);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, params.autogroup]);

  async function getLotReport(autogroup) {
    const items = [];
    console.log(userInfo.org);
    console.log(autogroup);
    const docRef = collection(
      db,
      "orgs",
      userInfo.org,
      "lots",
      autogroup,
      "countReport"
    );
    console.log(autogroup);
    const querySnapshot = await getDocs(docRef);

    querySnapshot.forEach((doc) => {
      items.push(doc.data());
      // console.log("new data --> " + doc.data());
    });
    console.log(items);

    setFetchDB(false);

    var filtedIssues = items.filter((e) => e.note !== "");
    setVins(filtedIssues);
  }

  if (fetchDB) {
    return (
      <DoubleBubble
        text={loadingText}
        center={true}
        width={"150px"}
        height={"150px"}
      />
    );
  }

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, vins);
        doc.save(params.autogroup + "_Issues_" + date + ".pdf");
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(vins);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const filename = params.autogroup + " Issues";
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, filename);
    });
  };

  function saveAsExcelFile(buffer, fileName) {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + "_" + date + EXCEL_EXTENSION);
    });
  }

  // function getTodaysDate() {
  //   var today = new Date();
  //   var dd = String(today.getDate()).padStart(2, "0");
  //   var mm = String(today.getMonth() + 1).padStart(2, "0");
  //   var yyyy = today.getFullYear();

  //   return dd + "-" + mm + "-" + yyyy;
  // }

  const emptyMessage = (
    <div className="md-4 text-center">
      <h4>No Results Found</h4>
      {/* <button
          type="button"
          className="btn btn-secondary w-full py-9px"
          style={{ minWidth: 313 }}
          onClick={() => history.push("/")}
        >Home</button>}

      {/* <Button type="button" onClick={() => history.push("/")}>
        Return Home
      </Button> */}
    </div>
  );


  const lotHeader = (
    <>
      <div>
        <div
          class="d-flex justify-content-md-between justify-content-center 
        algin-items-center flex-wrap text-center text-md-left"
          style={{ marginTop: 1.75 }}
        >
          <div class="d-flex flex-column">
            <h4 class="d-flex justify-content-start report-title text-left mb-2">
              {params.autogroup} Issue Report
            </h4>
            <p class="d-flex justify-content-start report-subtext">List of Inventory tagged with Issues.</p>
          </div>
        </div>

        <div class="d-flex justify-content-md-between justify-content-center algin-items-center flex-wrap mt-3">
          <div
            class="form-group has-search w-100 mb-0"
            style={{ maxWidth: 373 }}
          >
            <img src={searchIcon} class="form-control-feedback" alt="" />
            <input
              type="text"
              class="form-control form-search"
              placeholder="Search..."
              onInput={(e) => setGlobalFilter(e.target.value)}
            />
          </div>

          <div class="d-flex mt-3 mt-md-0" style={{ gap: 10 }}>
            <button
              type="button"
              className="btn btn-secondary w-full py-9px d-flex align-items-center"
              style={{ maxWidth: 100, gap: 10 }}
              onClick={exportExcel}
            >
              <img src={downloadIcon} alt="" />
              <span>EXCEL</span>
            </button>

            <button
              type="button"
              icon="pi pi-file-excel"
              className="btn btn-secondary w-full py-9px d-flex align-items-center"
              style={{ maxWidth: 100, gap: 10 }}
              onClick={exportPdf}
            >
              <img src={downloadIcon} alt="" />
              <span>PDF</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Container>
      <div className="physical-count-datatable">
        {lotHeader}
        <DataTable
          id="countTable"
          value={vins}
          paginator
          rows={10}
          // header={header}
          globalFilter={globalFilter}
          emptyMessage={emptyMessage}
        >
          <Column field="vin" header="VIN" sortable></Column>
          <Column field="note" header="Issue" sortable></Column>
          <Column field="entry" header="Entry" sortable></Column>
          <Column field="date" header="Date" sortable></Column>
          <Column field="time" header="Time" sortable></Column>
        </DataTable>
      </div>
    </Container>
  );
}

export default IssueReport;
